import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  useTranslation,
} from "react-i18next";

import {
  useDispatch,
  useSelector,
} from "react-redux";

import {
  useNavigate,
} from "react-router-dom";

import axios from "axios";

import {
  DataGrid,
} from "@mui/x-data-grid";

import {
  ThemeProvider,
  createTheme,
} from "@mui/material";

import {
  motion,
} from "framer-motion";

import {
  FiCalendar,
  FiEdit3,
  FiImage,
  FiMessageSquare,
  FiPlus,
  FiTrash2,
  FiUsers,
} from "react-icons/fi";

import {
  getFillterReviews,
} from "../../redux/actions/reviews";

import {
  Loader,
} from "../../components/utils";

import {
  useStateContext,
} from "../../context/ContextProvider";

import {
  BaseUrl,
  media,
} from "../../server";

import {
  truncateText,
} from "../hooks/TextVeiw";

import {
  localeTextGrid,
} from "../../constants";

import {
  toast,
} from "react-toastify";

import ReviewsFilter
  from "./utils/ReviewsFilter";


function DAllReviews() {
  const {
    t,
    i18n,
  } = useTranslation();

  const dispatch =
    useDispatch();

  const navigate =
    useNavigate();

  const {
    currentDir,
  } = useStateContext();


  const isArabic =
    i18n.language === "ar" ||
    i18n.language?.startsWith("ar");


  /* =====================================
      REDUX
  ====================================== */

  const {
    isLoading,
    FillterReviews,
    pagination,
  } = useSelector(
    (state) =>
      state.Reviews
  );


  /* =====================================
      FILTER STATES
  ====================================== */

  const [
    titleAr,
    setTitleAr,
  ] = useState("");


  const [
    titleEn,
    setTitleEn,
  ] = useState("");


  const [
    date,
    setDate,
  ] = useState("");


  /* =====================================
      DELETE
  ====================================== */

  const [
    deletingId,
    setDeletingId,
  ] = useState(null);


  /* =====================================
      PAGINATION
  ====================================== */

  const [
    paginationModel,
    setPaginationModel,
  ] = useState({
    pageSize: 10,
    page: 0,
  });


  const page =
    paginationModel.page;

  const limit =
    paginationModel.pageSize;


  /* =====================================
      SAFE DATA
  ====================================== */

  const reviews =
    Array.isArray(
      FillterReviews
    )
      ? FillterReviews
      : [];


  const totalItems =
    pagination
      ?.totalItems ||
    0;


  /* =====================================
      GET REVIEWS
  ====================================== */

  useEffect(() => {

    dispatch(
      getFillterReviews(
        page,
        limit,
        titleAr,
        titleEn,
        date
      )
    );

  }, [
    page,
    limit,
    titleAr,
    titleEn,
    date,
    dispatch,
  ]);


  /* =====================================
      RESET PAGE ON FILTER
  ====================================== */

  useEffect(() => {

    setPaginationModel(
      (prev) => ({
        ...prev,
        page: 0,
      })
    );

  }, [
    titleAr,
    titleEn,
    date,
  ]);


  /* =====================================
      DELETE REVIEW
  ====================================== */

  const deleteReviewHandler =
    async (id) => {

      if (deletingId) {
        return;
      }


      try {

        setDeletingId(id);


        const {
          data,
        } = await axios.delete(
          `${BaseUrl}/reviews/${id}`,
          {
            withCredentials:
              true,
          }
        );


        if (
          data?.success
        ) {

          toast.success(
            <span
              className="
                font-kufi
                text-sm

                text-tcolor-4
                dark:text-tcolor-1
              "
            >
              {t(
                "Review deleted successfully!"
              )}
            </span>
          );


          /*
           * إذا حذفنا آخر مراجعة
           * في الصفحة.
           */

          if (
            reviews.length === 1 &&
            page > 0
          ) {

            setPaginationModel(
              (prev) => ({
                ...prev,
                page:
                  prev.page - 1,
              })
            );

            return;
          }


          await dispatch(
            getFillterReviews(
              page,
              limit,
              titleAr,
              titleEn,
              date
            )
          );

        }

      } catch (error) {

        const errorMessage =
          error?.response
            ?.data?.message ||
          error?.message ||
          t(
            "An error occurred"
          );


        toast.error(
          <span
            className="
              font-kufi
              text-sm
            "
          >
            {errorMessage}
          </span>
        );

      } finally {

        setDeletingId(
          null
        );

      }
    };


  /* =====================================
      EDIT REVIEW
  ====================================== */

  const updateReviewHandler =
    (id) => {

      navigate(
        `/EditReviewPage/${id}`
      );

    };


  /* =====================================
      FORMAT DATE
  ====================================== */

  const formatDate =
    (value) => {

      if (!value) {
        return "-";
      }


      const parsedDate =
        new Date(value);


      if (
        Number.isNaN(
          parsedDate.getTime()
        )
      ) {
        return value;
      }


      return parsedDate
        .toLocaleDateString(
          isArabic
            ? "ar-EG"
            : "en-GB",

          {
            day:
              "2-digit",

            month:
              "2-digit",

            year:
              "numeric",
          }
        );

    };


  /* =====================================
      MUI
  ====================================== */

  const theme =
    useMemo(
      () =>
        createTheme({
          direction:
            currentDir,

          typography: {
            fontFamily:
              "inherit",
          },
        }),
      [
        currentDir,
      ]
    );


  /* =====================================
      COLUMNS
  ====================================== */

  const columns =
    useMemo(
      () => [

        /* =============================
            IMAGE
        ============================== */

        {
          field:
            "Image",

          headerName:
            t("Image"),

          width: 95,

          minWidth: 95,

          sortable:
            false,

          filterable:
            false,

          align:
            "center",

          headerAlign:
            "center",

          renderCell: (
            params
          ) => (

            <div
              className="
                flex

                w-full
                h-full

                items-center
                justify-center
              "
            >

              {params.value ? (

                <img
                  src={`${media}${params.value}`}

                  alt={
                    params.row
                      ?.titleAr ||
                    t("Customer")
                  }

                  loading="lazy"

                  className="
                    w-[52px]
                    h-[52px]

                    rounded-full

                    object-cover

                    border-2
                    border-color-1/15

                    shadow-sm
                  "
                />

              ) : (

                <div
                  className="
                    flex

                    w-[52px]
                    h-[52px]

                    items-center
                    justify-center

                    rounded-full

                    bg-color-1/10

                    text-color-1
                  "
                >
                  <FiImage />
                </div>

              )}

            </div>

          ),
        },


        /* =============================
            ARABIC NAME
        ============================== */

        {
          field:
            "titleAr",

          headerName:
            t(
              "Name (Ar)"
            ),

          minWidth: 155,

          flex: 0.7,

          sortable:
            false,

          filterable:
            false,

          renderCell: (
            params
          ) => (

            <div
              dir="rtl"

              className="
                flex

                w-full
                h-full

                items-center
              "
            >

              <span
                className="
                  block

                  w-full

                  overflow-hidden
                  text-ellipsis
                  whitespace-nowrap

                  font-kufi
                  font-semibold

                  text-[12px]

                  text-color-2
                  dark:text-white
                "

                title={
                  params.value ||
                  ""
                }
              >
                {
                  params.value ||
                  "-"
                }
              </span>

            </div>

          ),
        },


        /* =============================
            ENGLISH NAME
        ============================== */

        {
          field:
            "titleEn",

          headerName:
            t(
              "Name (En)"
            ),

          minWidth: 160,

          flex: 0.7,

          sortable:
            false,

          filterable:
            false,

          renderCell: (
            params
          ) => (

            <div
              dir="ltr"

              className="
                flex

                w-full
                h-full

                items-center
              "
            >

              <span
                className="
                  block

                  w-full

                  overflow-hidden
                  text-ellipsis
                  whitespace-nowrap

                  font-medium

                  text-[12px]

                  text-color-2
                  dark:text-white/90
                "

                title={
                  params.value ||
                  ""
                }
              >
                {
                  params.value ||
                  "-"
                }
              </span>

            </div>

          ),
        },


        /* =============================
            ARABIC REVIEW
        ============================== */

        {
          field:
            "textAr",

          headerName:
            t(
              "Review (Ar)"
            ),

          minWidth: 250,

          flex: 1.3,

          sortable:
            false,

          filterable:
            false,

          renderCell: (
            params
          ) => (

            <div
              dir="rtl"

              className="
                flex

                w-full
                h-full

                items-center
              "
            >

              <p
                className="
                  w-full

                  overflow-hidden

                  font-kufi

                  text-[10px]

                  leading-6

                  text-color-2/60
                  dark:text-white/55
                "
              >
                {truncateText(
                  params.value ||
                    "",
                  8
                )}
              </p>

            </div>

          ),
        },


        /* =============================
            ENGLISH REVIEW
        ============================== */

        {
          field:
            "textEn",

          headerName:
            t(
              "Review (En)"
            ),

          minWidth: 250,

          flex: 1.3,

          sortable:
            false,

          filterable:
            false,

          renderCell: (
            params
          ) => (

            <div
              dir="ltr"

              className="
                flex

                w-full
                h-full

                items-center
              "
            >

              <p
                className="
                  w-full

                  overflow-hidden

                  text-[10px]

                  leading-6

                  text-color-2/60
                  dark:text-white/55
                "
              >
                {truncateText(
                  params.value ||
                    "",
                  8
                )}
              </p>

            </div>

          ),
        },


        /* =============================
            DATE
        ============================== */

        {
          field:
            "date",

          headerName:
            t("Date"),

          width: 135,

          minWidth: 135,

          sortable:
            false,

          filterable:
            false,

          align:
            "center",

          headerAlign:
            "center",

          renderCell: (
            params
          ) => (

            <div
              className="
                flex

                w-full
                h-full

                items-center
                justify-center
              "
            >

              <div
                className="
                  inline-flex

                  items-center

                  gap-1.5

                  rounded-lg

                  bg-color-1/[0.07]

                  px-2.5
                  py-1.5

                  font-kufi
                  text-[9px]

                  text-color-1

                  whitespace-nowrap
                "
              >
                <FiCalendar
                  size={11}
                />

                {formatDate(
                  params.value
                )}
              </div>

            </div>

          ),
        },


        /* =============================
            ACTIONS
        ============================== */

        {
          field:
            "actions",

          headerName:
            t("Actions"),

          width: 195,

          minWidth: 195,

          sortable:
            false,

          filterable:
            false,

          align:
            "center",

          headerAlign:
            "center",

          renderCell: (
            params
          ) => {

            const id =
              params.row._id;


            const isDeleting =
              deletingId ===
              id;


            return (
              <div
                className="
                  flex

                  w-full
                  h-full

                  items-center
                  justify-center

                  gap-2
                "
              >

                {/* EDIT */}

                <motion.button
                  type="button"

                  whileTap={{
                    scale: 0.96,
                  }}

                  disabled={
                    Boolean(
                      deletingId
                    )
                  }

                  onClick={() =>
                    updateReviewHandler(
                      id
                    )
                  }

                  className="
                    inline-flex

                    h-10

                    min-w-[78px]

                    items-center
                    justify-center

                    gap-2

                    rounded-xl

                    border
                    border-color-1/20

                    bg-color-1/10

                    px-3

                    font-kufi
                    text-[10px]

                    text-color-1

                    whitespace-nowrap

                    transition-all

                    hover:bg-color-1
                    hover:text-white

                    disabled:opacity-40
                  "
                >

                  <FiEdit3
                    size={12}
                  />

                  {t(
                    "Edit"
                  )}

                </motion.button>


                {/* DELETE */}

                <motion.button
                  type="button"

                  whileTap={{
                    scale: 0.96,
                  }}

                  disabled={
                    Boolean(
                      deletingId
                    )
                  }

                  onClick={() =>
                    deleteReviewHandler(
                      id
                    )
                  }

                  className="
                    inline-flex

                    h-10

                    min-w-[78px]

                    items-center
                    justify-center

                    gap-2

                    rounded-xl

                    border
                    border-red-500/15

                    bg-red-500/[0.05]

                    px-3

                    font-kufi
                    text-[10px]

                    text-red-500

                    whitespace-nowrap

                    transition-all

                    hover:border-red-500
                    hover:bg-red-500
                    hover:text-white

                    disabled:opacity-40
                  "
                >

                  {isDeleting ? (

                    <span
                      className="
                        w-4
                        h-4

                        rounded-full

                        border-2
                        border-current
                        border-t-transparent

                        animate-spin
                      "
                    />

                  ) : (

                    <>
                      <FiTrash2
                        size={12}
                      />

                      {t(
                        "Delete"
                      )}
                    </>

                  )}

                </motion.button>

              </div>
            );
          },
        },

      ],

      [
        t,
        deletingId,
        isArabic,
      ]
    );


  /* =====================================
      INITIAL LOADING
  ====================================== */

  if (
    isLoading &&
    reviews.length === 0
  ) {
    return <Loader />;
  }


  return (
    <motion.div
      initial={{
        opacity: 0,
        y: 15,
      }}

      animate={{
        opacity: 1,
        y: 0,
      }}

      className="
        w-full

        max-w-[1600px]

        mx-auto
      "
    >

      {/* =====================================
          HERO
      ====================================== */}

      <section
        className="
          relative

          overflow-hidden

          rounded-[2rem]

          bg-color-2

          px-5
          py-6

          md:px-8
          md:py-8

          mb-6

          text-white

          shadow-[0_18px_50px_rgba(68,37,20,.13)]
        "
      >

        <div
          className="
            absolute

            -top-28
            -end-20

            w-72
            h-72

            rounded-full

            bg-color-1/20

            blur-[100px]

            pointer-events-none
          "
        />


        <div
          className="
            absolute

            -bottom-28
            start-20

            w-60
            h-60

            rounded-full

            bg-color-1/10

            blur-[90px]

            pointer-events-none
          "
        />


        <div
          className="
            relative
            z-10

            flex
            flex-col

            md:flex-row
            md:items-center
            md:justify-between

            gap-5
          "
        >

          <div
            className="
              flex

              items-center

              gap-4
            "
          >

            <div
              className="
                flex

                w-14
                h-14

                shrink-0

                items-center
                justify-center

                rounded-2xl

                bg-color-1

                text-2xl

                shadow-[0_10px_30px_rgba(165,119,58,.28)]
              "
            >
              <FiMessageSquare />
            </div>


            <div>

              <span
                className="
                  font-kufi

                  text-[10px]

                  text-color-1
                "
              >
                {t(
                  "Reviews Management"
                )}
              </span>


              <h1
                className="
                  mt-1

                  font-kufi
                  font-bold

                  text-xl
                  md:text-3xl
                "
              >
                {t(
                  "Reviews"
                )}
              </h1>


              <p
                className="
                  max-w-xl

                  mt-2

                  font-kufi

                  text-[10px]
                  md:text-xs

                  leading-6

                  text-white/50
                "
              >
                {t(
                  "Manage customer reviews displayed on Yaman restaurant website"
                )}
              </p>

            </div>

          </div>


          {/* CREATE REVIEW */}

          <button
            type="button"

            onClick={() =>
              navigate(
                "/CreateReviewPage"
              )
            }

            className="
              flex

              min-h-[44px]

              items-center
              justify-center

              gap-2

              rounded-full

              bg-color-1

              px-5

              font-kufi
              text-xs

              text-white

              transition-all

              hover:bg-white
              hover:text-color-2
            "
          >
            <FiPlus />

            {t(
              "Create Review"
            )}
          </button>

        </div>

      </section>


      {/* =====================================
          COUNT + FILTER
      ====================================== */}

      <section
        className="
          grid

          grid-cols-1

          xl:grid-cols-[220px_1fr]

          gap-4

          mb-5
        "
      >

        {/* COUNT */}

        <motion.div
          whileHover={{
            y: -3,
          }}

          className="
            relative

            overflow-hidden

            rounded-[1.5rem]

            border
            border-color-2/10
            dark:border-white/10

            bg-back-primery
            dark:bg-back-darksecondary

            p-5

            shadow-[0_8px_25px_rgba(68,37,20,.04)]
          "
        >

          <div
            className="
              flex

              items-center
              justify-between
            "
          >

            <div>

              <span
                className="
                  block

                  text-3xl
                  font-bold

                  text-color-2
                  dark:text-white
                "
              >
                {totalItems}
              </span>


              <span
                className="
                  mt-1

                  block

                  font-kufi
                  font-semibold

                  text-[11px]

                  text-color-2/65
                  dark:text-white/60
                "
              >
                {t(
                  "Total Reviews"
                )}
              </span>


              <span
                className="
                  mt-2

                  block

                  font-kufi
                  text-[9px]

                  text-color-2/35
                  dark:text-white/30
                "
              >
                {t(
                  "Customer experiences"
                )}
              </span>

            </div>


            <div
              className="
                flex

                w-11
                h-11

                items-center
                justify-center

                rounded-2xl

                bg-color-1/10

                text-color-1
              "
            >
              <FiUsers />
            </div>

          </div>


          <span
            className="
              absolute

              bottom-0
              start-0

              w-14
              h-[3px]

              bg-color-1
            "
          />

        </motion.div>


        {/* FILTER */}

        <div
          className="
            rounded-[1.5rem]

            border
            border-color-2/10
            dark:border-white/10

            bg-back-primery
            dark:bg-back-darksecondary

            p-4
            md:p-5

            shadow-[0_8px_25px_rgba(68,37,20,.04)]
          "
        >

          <div
            className="
              flex

              items-center

              gap-3

              mb-4
            "
          >

            <div
              className="
                flex

                w-9
                h-9

                items-center
                justify-center

                rounded-xl

                bg-color-1/10

                text-color-1
              "
            >
              <FiMessageSquare />
            </div>


            <div>

              <h2
                className="
                  font-kufi
                  font-semibold

                  text-xs

                  text-color-2
                  dark:text-white
                "
              >
                {t(
                  "Filter Reviews"
                )}
              </h2>


              <p
                className="
                  mt-1

                  font-kufi
                  text-[9px]

                  text-color-2/40
                  dark:text-white/30
                "
              >
                {t(
                  "Find reviews by customer name or date"
                )}
              </p>

            </div>

          </div>


          <ReviewsFilter
            titleAr={
              titleAr
            }

            setTitleAr={
              setTitleAr
            }

            titleEn={
              titleEn
            }

            setTitleEn={
              setTitleEn
            }

            date={
              date
            }

            setDate={
              setDate
            }
          />

        </div>

      </section>


      {/* =====================================
          TABLE
      ====================================== */}

      <section
        className="
          overflow-hidden

          rounded-[1.75rem]

          border
          border-color-2/10
          dark:border-white/10

          bg-back-primery
          dark:bg-back-darksecondary

          shadow-[0_12px_35px_rgba(68,37,20,.05)]
        "
      >

        {/* HEADER */}

        <div
          className="
            flex

            items-center

            gap-3

            px-5
            md:px-6

            py-5

            border-b
            border-color-2/10
            dark:border-white/10
          "
        >

          <div
            className="
              flex

              w-10
              h-10

              items-center
              justify-center

              rounded-xl

              bg-color-1/10

              text-color-1
            "
          >
            <FiMessageSquare />
          </div>


          <div>

            <h2
              className="
                font-kufi
                font-bold

                text-sm

                text-color-2
                dark:text-white
              "
            >
              {t(
                "Reviews List"
              )}
            </h2>


            <p
              className="
                mt-1

                font-kufi
                text-[9px]

                text-color-2/45
                dark:text-white/35
              "
            >
              {t(
                "View edit and manage customer reviews"
              )}
            </p>

          </div>

        </div>


        {/* DATA GRID */}

        <ThemeProvider
          theme={theme}
        >

          <div
            className="
              w-full

              overflow-x-auto

              p-3
              md:p-5
            "
          >

            <DataGrid
              rows={
                reviews
              }

              columns={
                columns
              }

              getRowId={(
                row
              ) =>
                row._id
              }

              disableRowSelectionOnClick

              disableColumnSelector

              pagination

              paginationMode="server"

              rowCount={
                totalItems
              }

              paginationModel={
                paginationModel
              }

              onPaginationModelChange={
                setPaginationModel
              }

              pageSizeOptions={[
                10,
                20,
                50,
              ]}

              localeText={
                localeTextGrid
              }

              loading={
                isLoading
              }

              rowHeight={
                76
              }

              columnHeaderHeight={
                56
              }

              sx={{
                width:
                  "100%",

                minWidth:
                  "1350px",

                border:
                  "none",

                backgroundColor:
                  "transparent",


                "& .MuiDataGrid-columnHeaders":
                  {
                    backgroundColor:
                      "#fff",

                    borderBottom:
                      "1px solid rgba(68,37,20,.09)",
                  },


                "& .MuiDataGrid-columnHeader":
                  {
                    paddingLeft:
                      "14px",

                    paddingRight:
                      "14px",

                    outline:
                      "none !important",
                  },


                "& .MuiDataGrid-columnHeaderTitleContainer":
                  {
                    height:
                      "100%",

                    display:
                      "flex",

                    alignItems:
                      "center",
                  },


                "& .MuiDataGrid-columnHeaderTitle":
                  {
                    fontSize:
                      "10px",

                    fontWeight:
                      "700",

                    whiteSpace:
                      "nowrap",
                  },


                "& .MuiDataGrid-cell":
                  {
                    paddingLeft:
                      "14px",

                    paddingRight:
                      "14px",

                    borderBottom:
                      "1px solid rgba(68,37,20,.06)",

                    outline:
                      "none !important",

                    overflow:
                      "hidden",

                    display:
                      "flex",

                    alignItems:
                      "center",
                  },


                "& .MuiDataGrid-row":
                  {
                    transition:
                      "background-color .2s ease",
                  },


                "& .MuiDataGrid-row:hover":
                  {
                    backgroundColor:
                      "rgba(165,119,58,.045)",
                  },


                "& .MuiDataGrid-footerContainer":
                  {
                    minHeight:
                      "58px",

                    borderTop:
                      "1px solid rgba(68,37,20,.08)",
                  },


                "& .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus":
                  {
                    outline:
                      "none",
                  },
              }}
            />

          </div>

        </ThemeProvider>

      </section>

    </motion.div>
  );
}


export default DAllReviews;